import type { UserMeResponse } from '@/backend/types'
import { get } from './client'

export const PATH = '/api/users/me' as const

export type GetUserResponse = UserMeResponse
export type GetUserRequest = undefined

export const getUser = () => get<GetUserRequest, GetUserResponse, typeof PATH>(PATH, undefined)
